import { Pie } from '../BaseCharts'
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  extends: Pie,
  data: function() {
    return {
      pendingCount: '',
      deliveredCount: '',
      NDRCount: ''
    }
  },
  created: function() {
    this.getPendingCount()
  },
  mounted () {
  },

  methods: {
    getPendingCount: function() {
      var userdata = localStorage.getItem('userData');
      var userInfo = JSON.parse(userdata);
      var usrObj = {
        pickuplocationpincode: `${userInfo.pickuplocationpincode}`
      };
       this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getdashboardchartdata`, usrObj)
        .then((response) => {
          if (response) {
            var result = JSON.parse(response.bodyText);
            //this.pendingCount = parseInt(result.returnvalue[0].totalofd) + parseInt(result.returnvalue[0].pickuppending);
            this.pendingCount = parseInt(result.returnvalue[0].deliverypending);

            if(isNaN(this.pendingCount)) {
            this.pendingCount = 0;
            }
            //this.deliveredCount = parseInt(result.returnvalue[0].totaldelivered);
            this.deliveredCount = parseInt(result.returnvalue[0].totaldelivered);
            if(isNaN(this.deliveredCount)) {
            this.deliveredCount = 0;
            }
           // this.NDRCount = parseInt(result.returnvalue[0].totalrto);
            this.NDRCount= parseInt(result.returnvalue[0].handoverpending);
             if(isNaN(this.NDRCount)) {
            this.NDRCount = 0;
            }
           
            document.getElementById('deliverypending').innerHTML=this.pendingCount;
            document.getElementById('delivered').innerHTML=this.deliveredCount;
            document.getElementById('ndr').innerHTML=this.NDRCount;

            var total_lables_delivery = parseInt(this.pendingCount) + parseInt(this.deliveredCount) + parseInt(this.NDRCount);

            this.renderChart({
              labels: [' Delivery Pending' ,'Delivered','Handover Pending'],
              datasets: [
                {
                  backgroundColor: [
                    '#FF69B4',
                    '#9370DB',
                    '#dd4b39'
                  ],
                  data: [this.pendingCount, this.deliveredCount, this.NDRCount]
                }
              ]
            }, {
              responsive: true,
              maintainAspectRatio: false,
                tooltips: {
                  callbacks: {
                    title: function(tooltipItem, data) {
                      return data['labels'][tooltipItem[0]['index']];
                    },
                    label: function(tooltipItem, data) {
                      return data['datasets'][0]['data'][tooltipItem['index']];
                    },
                    afterLabel: function(tooltipItem, data) {
                      var dataset = data['datasets'][0];
                      // console.log(total_lables_delivery);
                      var percent = Math.round((dataset['data'][tooltipItem['index']] / total_lables_delivery) * 100)
                      return '(' + percent + '%)';
                    }
                  },
                  //backgroundColor: '#FFF',
                  titleFontSize: 16,
                  titleFontColor: '#FFFFFF',
                  bodyFontColor: '#FFFFFF',
                  bodyFontSize: 14,
                  displayColors: true
                }
              })
          } else {
            alert('Data not found')
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
  }
}
